<template>
  <v-container fluid class="pa-0 mt-5 fill-width">
    <v-card class="pa-0">
      <h2 class="text-center mb-3">
        TIÊU CHUẨN ĐẠO ĐỨC (HVS Ethics)
      </h2>

      <div id="loader"></div>

      <DxScrollView height="100%" width="100%">
        <v-list style="padding: 20px;">
          <v-list-item
            v-for="(docItem, i) in docList"
            :key="i"
            :class="i % 2 === 0 ? 'row-light' : 'row-dark'"
          >
      
            <v-list-item-content style="max-width: 40px;">
              {{ i + 1 }}
            </v-list-item-content>

            
            <v-list-item-content class="list-text">
              {{ language === 'EN' ? docItem.title : docItem.titleVnm }}
            </v-list-item-content>

    
            <v-list-item-action>
              <v-icon size="28" class="mr-2" @click="previewPDF(docItem.filePath, docItem.fileNm)">
                mdi-eye
              </v-icon>
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </DxScrollView>

      <HDPdfViewer
        v-if="showPreview"
        :src="pdfUrl"
        @close="closePreview"
        @download="downloadFile"
      />
    </v-card>

    <VueToastify :notifyAction="notifyAction"/>
  </v-container>
</template>

<script>
import { getDocList, getFilePdf } from "@/api/view/mis/10/v10a8000.js"
import VueToastify from "@/components/toastify/VueToastify.vue"
import HDPdfViewer from "@/layout/components/HDPdfViewer.vue"
import { DxScrollView } from "devextreme-vue/scroll-view";

export default {
  components: { VueToastify, HDPdfViewer, DxScrollView },
  data() {
    return {
      showPreview: false,
      pdfUrl: null,
      empCode: "",
      language: "",
      docList: []
    }
  },
  async mounted() {
    this.empCode = this.$store.state.user.userId

    const vnCodes = ["2", "5", "6", "7"]
    this.language = vnCodes.includes(this.empCode.substring(0, 1)) ? "VN" : "EN" ;

    await this.getDocList()
  },
  methods: {
    notifyAction(notifyInfo, action) {
      this.$EventBus.$emit(`${this.$route.meta.menu_id}_notifyAction`, { notifyInfo, action })
    },
    async getDocList() {
      let parm = { userId: this.empCode, lang: this.language }
      try {
        const res = await getDocList(parm)
        this.docList = res.list
       // console.log(res)

      } catch (e) {
        console.error(e)
      }
    },
    async previewPDF(strfilePath, strfileNm) {
      const params = { filePath: strfilePath, fileNm: strfileNm }
      loading(true)
      try {
        
        const res = await getFilePdf(params)        
        this.pdfUrl = window.URL.createObjectURL(res)
        
        //console.log(this.pdfUrl) ;
        this.showPreview = true

      } catch (e) {
        console.error(e)
        alert("Download PDF file error " + e.error)

      } finally {
        loading(false)
      }
    },
    downloadFile() {
      const link = document.createElement("a")
      link.href = this.pdfUrl
      link.download = `Conduct_${this.empCode}.pdf`
      link.click()
    },

    closePreview() {
      this.showPreview = false
      if (this.pdfUrl) {
        URL.revokeObjectURL(this.pdfUrl)
        this.pdfUrl = null
      }
    }
  }
}

function loading(show) {
  document.getElementById("loader").style.display = show ? "block" : "none"
}
</script>

<style scoped>
.list-text {
  font-size: 18px;       /* Font chữ lớn hơn */
}

.row-light {
  background-color: #f9f9f9;  /* Màu nền sáng */
}

.row-dark {
  background-color: #eaeaea;  /* Màu nền tối hơn */
}

.v-list-item {
  transition: background 0.3s;
}

.v-list-item:hover {
  background-color: #d6e4f0;  /* Hiệu ứng hover */
}


.preview-img {
  max-height: 80px;
  margin-bottom: 10px;
}


.fill-width {
  max-width: 100% !important;
  padding-left: 4px !important;
  padding-right: 4px !important;
}
.v-container {
  max-width: 100% !important;
  padding-left: 4px !important;
  padding-right: 4px !important;
}

.v-card {
  max-width: 1000px;
  width: 100% ;
  margin: auto;
}


.pdf-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.6);
  display: flex;
  justify-content: center;
  align-items: center;
}

.pdf-container {
  width: 80%;
  height: 80%;
  background: white;
  position: relative;
}

.close-btn {
  position: absolute;
  top: 5px;
  right: 10px;
  z-index: 10;
}

.pdf-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.6);
  z-index: 9999;
}

.pdf-modal {
  position: absolute;
  top: 5%;
  left: 50%;
  transform: translateX(-50%);
  width: 80%;
  height: 90%;
  background: #fff;
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  overflow: hidden;
}

/* HEADER */
.pdf-header {
  padding: 10px;
  background: #2c3e50;
  color: white;
  display: flex;
  justify-content: space-between;
}

/* BODY */
.pdf-body {
  flex: 1;
}

.pdf-body iframe {
  width: 100%;
  height: 100%;
}

/* FOOTER */
.pdf-footer {
  padding: 10px;
  text-align: right;
  border-top: 1px solid #ddd;
}

.pdf-footer button {
  margin-left: 10px;
  padding: 6px 12px;
}

@media (max-width: 600px) {
  .v-card {
    margin: 0 !important;
    margin-top: 10px !important;
    border-radius: 0 !important;
  }
}

#loader {
  position: absolute;
  left: 50%;
  top: 50%;
  z-index: 1;
  width: 120px;
  height: 120px;
  margin: -76px 0 0 -76px;
  border: 16px solid #f3f3f3;
  border-radius: 50%;
  border-top: 16px solid #3498db;
  -webkit-animation: spin 2s linear infinite;
  animation: spin 2s linear infinite;
  display: none;
}

@-webkit-keyframes spin {
  0% { -webkit-transform: rotate(0deg); }
  100% { -webkit-transform: rotate(360deg); }
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* Add animation to "page content" */
.animate-bottom {
  position: relative;
  -webkit-animation-name: animatebottom;
  -webkit-animation-duration: 1s;
  animation-name: animatebottom;
  animation-duration: 1s
}

@-webkit-keyframes animatebottom {
  from { bottom:-100px; opacity:0 } 
  to { bottom:0px; opacity:1 }
}

@keyframes animatebottom { 
  from{ bottom:-100px; opacity:0 } 
  to{ bottom:0; opacity:1 }
}
</style>

<!-- <template>
  <v-container fluid class="pa-0 mt-5 fill-width">
    <v-card class="pa-0">
      <h2 class="text-center mb-3">
        TIÊU CHUẨN ĐẠO ĐỨC (HVS Ethics)
      </h2>

      <div id="loader"></div>

      <v-data-table
        :headers="headers"
        :items="docList"
        class="elevation-1 custom-table"
        hide-default-footer
      >
        <template v-slot:item.index="{ index }">
          {{ index + 1 }}
        </template>

        <template v-slot:item.title="{ item }">
          {{ language === 'EN' ? item.title : item.titleVnm }}
        </template>

        <template v-slot:item.actions="{ item }">
          <v-icon small class="mr-2" @click="previewPDF(item.filePath, item.fileNm)">
            mdi-eye
          </v-icon>
        </template>
      </v-data-table>

      <HDPdfViewer
        v-if="showPreview"
        :src="pdfUrl"
        @close="closePreview"
        @download="downloadFile"
      />
    </v-card>

    <VueToastify :notifyAction="notifyAction"/>
  </v-container>
</template>

<script>
import { getDocList, getFilePdf } from "@/api/view/mis/10/v10a8000.js"
import VueToastify from "@/components/toastify/VueToastify.vue"
import HDPdfViewer from "@/layout/components/HDPdfViewer.vue"

export default {
  components: { VueToastify, HDPdfViewer },
  data() {
    return {
      showPreview: false,
      pdfUrl: null,
      empCode: "",
      language: "",
      docList: [],
      headers: [
        { text: "STT", value: "index", width: 60 },
        { text: "Tiêu đề", value: "title", align: "start" },
        { text: "Hành động", value: "actions", sortable: false, width: 100 }
      ]
    }
  },
  async mounted() {
    this.empCode = this.$store.state.user.userId
    this.language = this.empCode.startsWith("9") ? "EN" : "VN"
    await this.getDocList()
  },
  methods: {
    notifyAction(notifyInfo, action) {
      this.$EventBus.$emit(`${this.$route.meta.menu_id}_notifyAction`, { notifyInfo, action })
    },
    async getDocList() {
      let parm = { userId: this.empCode, lang: this.language }
      try {
        const res = await getDocList(parm)
        this.docList = res.list
      } catch (e) {
        console.error(e)
      }
    },
    async previewPDF(strfilePath, strfileNm) {
      const params = { pdfUrl: strfilePath, fileNm: strfileNm}
      loading(true)
      try {
        const res = await getFilePdf(params)
        this.pdfUrl = window.URL.createObjectURL(res)
        this.showPreview = true
      } catch (e) {
        console.error(e)
        alert("Download lỗi")
      } finally {
        loading(false)
      }
    },
    downloadFile() {
      const link = document.createElement("a")
      link.href = this.pdfUrl
      link.download = `Consent_${this.empCode}.pdf`
      link.click()
    },
    closePreview() {
      this.showPreview = false
      if (this.pdfUrl) {
        URL.revokeObjectURL(this.pdfUrl)
        this.pdfUrl = null
      }
    }
  }
}

function loading(show) {
  document.getElementById("loader").style.display = show ? "block" : "none"
}
</script>

<style scoped>
.custom-table {
  font-size: 14px; /* Font chữ lớn hơn */
}

.custom-table .v-data-table__wrapper tr:nth-child(even) {
  background-color: #f9f9f9; /* Hàng chẵn sáng */
}

.custom-table .v-data-table__wrapper tr:nth-child(odd) {
  background-color: #eaeaea; /* Hàng lẻ tối hơn */
}

.custom-table .v-data-table__wrapper tr:hover {
  background-color: #d6e4f0; /* Hiệu ứng hover */
}
</style> -->
